import { ZapbotBlock } from "./types";

export function copy(block: ZapbotBlock): ZapbotBlock {
  return {
    ...block,
    config: {
      ...block.config,
      id: undefined,
    },
  };
}
